import { createContext, useContext, useEffect,useMemo, useState } from 'react';

const historyContext = createContext(null);

export const HistoryProvider = ({ children }) => {
  const [query, setQuery] = useState({});
  const [totalPush, setTotalPush] = useState(0);

  const pushQuery = (query) => {
    const url = new URL(window.location.href);
    const search = new URLSearchParams(query).toString();

    setQuery(query);

    if (search) {
      url.search = search;
    }
    setTotalPush(totalPush + 1);
    window.history.pushState({ ...query }, '', url);
  };

  const updateQuery = (query = {}) => {
    const search = {
      ...window.history.state,
      ...query,
    };

    pushQuery({ ...search, ...query });
  };

  const replace = (data, title, url) => window.history.replaceState(data, title, url);

  const go = (step = -1) => window.history.go(step);
  const back = () => window.history.back();

  const onPopState = ({ state = {} }) => setQuery(state);

  useEffect(() => {
    window.addEventListener('popstate', onPopState);

    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const value = useMemo(
    () => ({
      totalPush,
      pushQuery,
      updateQuery,
      back,
      replace,
      go,
      query,
    }),
    [query, totalPush]
  );

  return <historyContext.Provider value={value}>{children}</historyContext.Provider>;
};

export const useCtxHistory = () => useContext(historyContext);

export const withZippiaHistory = (C) => {
  const Component = (props) => {
    const zippiaHistory = useCtxHistory();

    return <C {...props} zippiaHistory={zippiaHistory} />;
  };

  Component.getInitialProps = C.getInitialProps;
  Component.__docgenInfo = C.__docgenInfo;

  return Component;
};
